/**
 * Created by mateimisarca on 2019-06-07
 */

import HomePage from './home-page';
export default HomePage;
